import React from "react";
import image1 from '../img/Stand by&&signal[lost]---Blending textures over AI generated images on Adobe Photoshop___2025-07[[3]].jpg'
export default function Machine_1_2_1() {
  return (
    <div className="panel-block">
     

      <div className="panel-container-left">
        <img
          loading="lazy"
          src={image1}
          alt="1.2.1 · THE FOG"
        />
      </div>

      <div className="panel-container-right">
         <h2>1.2.1 · THE FOG</h2>
        <p>It is not absence that prevents you from seeing.</p>
    <p>It is saturation.</p>
    <p>Too much of something you already know, something that is there but cannot be held by your hands.</p>
    <p>It is not access to information that creates ignorance.</p>
    <p>It is the excess of everything growing around it.</p>
      </div>
    </div>
  );
}
